import { render, staticRenderFns } from "./ProPresenterWidget.vue?vue&type=template&id=756fa830&scoped=true"
import script from "./ProPresenterWidget.vue?vue&type=script&lang=js"
export * from "./ProPresenterWidget.vue?vue&type=script&lang=js"
import style0 from "./ProPresenterWidget.vue?vue&type=style&index=0&id=756fa830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756fa830",
  null
  
)

export default component.exports